import { render, staticRenderFns } from "./doctorInfo.vue?vue&type=template&id=3c188112&scoped=true"
import script from "./doctorInfo.vue?vue&type=script&lang=js"
export * from "./doctorInfo.vue?vue&type=script&lang=js"
import style0 from "./doctorInfo.vue?vue&type=style&index=0&id=3c188112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c188112",
  null
  
)

export default component.exports